Promise = require 'bluebird'
PluginView = require 'app/scripts/views/plugin/plugin-view'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
t = require('app/scripts/views/internal/teacup-with-helpers')()

template = t.renderable ({ content } = {}) ->
  switch content.type
    when 'iframe'
      t.iframe '.plugin-iframe',
        allow: 'microphone; camera'
        sandbox: sandboxParams
        src: content.url
  return

module.exports = class PluginOverlayView extends PluginView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-overlay'

  renderOnce: ->
    @$el.html(template({ @content }))
    @initIFrames(@model)
    @
